<mat-form-field class="composite-target">
  <cng-chosen-correspondent-mail
    [formControl]="target"
    [agentChannel]="MailIn"
    addable
    removable
    [optTpl]="optTpl"
    [chipTpl]="chipTpl"
  ></cng-chosen-correspondent-mail>
  <mat-label title="{{ 'agent:contact.workspace.mail.transfer.composite_target' | i18next }}">
    {{ 'agent:contact.workspace.mail.transfer.composite_target' | i18next }}
  </mat-label>
  <mat-icon fontSet="mat" matSuffix>search</mat-icon>
  <mat-error *ngIf="target?.hasError('invalid_format')">
    {{ 'commons:basic.form.format_invalid' | i18next }}
  </mat-error>
</mat-form-field>

<ng-template #optTpl let-opt>
  <span [matTooltip]="[opt.value | customerName, opt.value.email] | joiner: ' - '">
    <ng-container *ngIf="!!opt.value.name"> {{ opt.value | customerName }} </ng-container>
    &lt;{{ opt.value.email }}&gt;
  </span>
</ng-template>

<ng-template #chipTpl let-opt>
  <span truncate [matTooltip]="opt.value.email">
    {{ opt.value.email }}
  </span>
</ng-template>
